import { EVENT_FROM_TOP_NAME, EVENT_TO_TOP_NAME, TIMEOUT_PREMATURE_LOGIN } from './consts';
import { debug } from './debug';
import { getLoginObject } from './externals/login';
import { getIS } from './namespace';
import { isObject } from './utils';
import { isCrossFrameBridgeActive } from './config';
// are we in top level?
export const isTopLevel = window.top === window.self && !window.frameElement;
// some metadata about TOP -> synced to frames
let topLevelInfo = {
    hasLoginBadge: false,
};
export const getTopLevelInfo = () => topLevelInfo;
/**
 * Feed all registered child frames
 */
export const feedChildFrames = (data) => {
    if (!isTopLevel || !isCrossFrameBridgeActive()) {
        return;
    }
    if (Array.isArray(getIS()._childFramesToFeed) && getIS()._childFramesToFeed.length) {
        const { identities, topLevelData } = data;
        getIS()._childFramesToFeed.forEach((f) => {
            try {
                (identities || topLevelData) && f.postMessage({ type: EVENT_FROM_TOP_NAME, identities, topLevelData }, '*');
            }
            catch (err) {
                debug({ type: 'error', message: 'Post message to child frame error', err });
            }
        });
    }
};
/**
 * Checking loop for login badge - is at least stub present?
 */
const loginBadgeCheck = () => {
    const interval = Math.max(TIMEOUT_PREMATURE_LOGIN / 10, 100);
    let attempts = 0;
    const maxAttempts = Math.floor(TIMEOUT_PREMATURE_LOGIN / interval);
    const badgeLoop = maxAttempts &&
        window.setInterval(() => {
            attempts++;
            const hasLogin = !!getLoginObject();
            if (hasLogin || attempts >= maxAttempts) {
                topLevelInfo.hasLoginBadge = hasLogin;
                badgeLoop && window.clearInterval(badgeLoop);
                feedChildFrames({ topLevelData: { hasLoginBadge: hasLogin } });
            }
        }, interval);
};
/**
 * Register new child IS subscriber / listener in top IS
 * Feed current identitites to child IS
 */
export const handlerFromChildMessage = (event, getter) => {
    var _a;
    if (event.source && ((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === EVENT_TO_TOP_NAME) {
        debug(`Registering child IS ${event.origin}`);
        getIS()._childFramesToFeed.push(event.source);
        feedChildFrames({ identities: getter() });
    }
};
/**
 * Receive in child IS idetitites data from top IS
 * Update self storage (just identities which are not already existing)
 */
export const handlerFromTopMessage = (event, updater) => {
    var _a, _b, _c, _d, _e;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === EVENT_FROM_TOP_NAME) {
        if (((_b = event.data) === null || _b === void 0 ? void 0 : _b.identities) && isObject((_c = event.data) === null || _c === void 0 ? void 0 : _c.identities)) {
            debug({ message: 'Data from top IS', identities: event.data.identities });
            updater(event.data.identities);
        }
        if (((_d = event.data) === null || _d === void 0 ? void 0 : _d.topLevelData) && isObject((_e = event.data) === null || _e === void 0 ? void 0 : _e.topLevelData)) {
            topLevelInfo = Object.assign(Object.assign({}, topLevelInfo), event.data.topLevelData);
        }
    }
};
/**
 * IS can be on page multiple times (in nested frames etc)
 * Child frame IS can ask / subscribe IS state (and its changes) to top frame IS
 */
export const initCrossFramesCommunication = (updater, getter) => {
    // communication disabled by config
    if (!isCrossFrameBridgeActive()) {
        return;
    }
    if (isTopLevel) {
        // register child IS subscriber / listener
        window.addEventListener('message', (event) => handlerFromChildMessage(event, getter));
        // check login badge and propagate
        loginBadgeCheck();
    }
    else {
        // cypress hack (cypress tests are running inside iframe -> window.top is not, what exected)
        let destination = 'top';
        try {
            destination = window.Cypress || window.parent.Cypress ? 'parent' : 'top';
        }
        catch (_a) {
            // no-op
        }
        // register self in top frame (top IS instance)
        window[destination].postMessage({ type: EVENT_TO_TOP_NAME }, '*');
        // listen to parent data
        window.addEventListener('message', (event) => handlerFromTopMessage(event, updater));
    }
};
